import React from 'react';
import { ModalContainer, ModalContent, ModalIcon, CloseButton } from './SuccessModal.styles';
import { SuccessModalProps } from './SuccessModal.types';
import { successIcon } from "assets/icons";
import { closeIcon as CloseIcon } from "assets/icons";

const SuccessModal: React.FC<SuccessModalProps> = ({ message, onClose }) => {
  return (
    <ModalContainer>
      <ModalContent>
        <CloseButton aria-label="Закрыть" onClick={onClose}><CloseIcon aria-hidden="true" /></CloseButton>
        <p>{message}</p>
        <ModalIcon as={successIcon} aria-hidden="true" />
      </ModalContent>
    </ModalContainer>
  );
};

export default SuccessModal;
